import React from 'react';
import {connect} from 'react-redux';

import strings from 'utils/strings';

import AudioPlayer from 'components/AudioPlayer';

import audioNo from 'assets/sounds/no/5 1 Leseforstaelse Intro.mp3';
import audioNn from 'assets/sounds/nn/5 1 Leseforstaelse Intro.mp3';
import audioNoNorming from '../../assets/sounds/adult/leseproven/no/5 1 Leseforstaelse Intro.mp3';
import audioNnNorming from '../../assets/sounds/adult/leseproven/nn/5 1 Leseforstaelse Intro.mp3';


import tutorialVideo from './assets/99c06a75c2d10f2ad5d81a1aa870fc65.mp4';

class Intro extends React.Component {
	constructor(props) {
		super(props);

		const audioObj = {
			no: audioNo,
			nn: audioNn,
		};
		const normingLanguageObj = {
			no: audioNoNorming,
			nn: audioNnNorming,
		};

		const isDldTest = this.props.isDldTest ? 1 : 0;
		this.audio =
			isDldTest === 1
				? normingLanguageObj[strings.getLanguage()]
				: audioObj[strings.getLanguage()];
	}

	render() {
		const {onNextStep, isDldTest} = this.props;

		let videoRef;

		return (
			<div>
				<div className={isDldTest ? 'text-center' : 'text-left'}>
					<p>
						<AudioPlayer
							autoplay
							inline
							onPause={() => {
								videoRef.play();
							}}
							onErrorPlay={() => {
								console.log('Something went wrong');
							}}
							src={this.audio}
						/>

						{isDldTest
							? strings.leseprovenNormingIntro
							: strings.leseprovenIntro}
					</p>
					<p>
						{isDldTest
							? strings.leseprovenNormingTimeLimit
							: strings.leseprovenTimeLimit}
					</p>
				</div>

				<div className="lit-preview">
					<p className="lit-preview__label">
						{strings.testLooksLikeThis}
					</p>
					<video
						className="lit-preview__video"
						loop
						ref={(ref) => {
							videoRef = ref;
						}}
						src={tutorialVideo}
					/>
				</div>
				<button
					className="lit-btn bg-primary"
					onClick={() => onNextStep()}
				>
					{strings.start}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
